var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGirlImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 362,
    height: 870,
    viewBox: "0 0 362 870",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2596",
    "data-name": "Rectangle 2596",
    width: 362,
    height: 870,
    transform: "translate(1210 210)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2584",
    "data-name": "Rectangle 2584",
    width: 300.131,
    height: 1099.042,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(-1210 -210)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6698",
    "data-name": "Group 6698",
    transform: "translate(1240.202 235.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6697",
    "data-name": "Group 6697",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M59.157,25.925S67.3-8,112.383,1.768s31.33,82.343,29.911,104.443,30.259,66.245-11.557,85.341c0,0-1.991,29.312-33.149,28.509s-47.53-36.875-45.263-45.506S59.157,25.925,59.157,25.925",
    transform: "translate(104.614 0.001)",
    fill: "#8f2c40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M50.415,39.661C44.743,17.383,63.313-.676,85.6,4.156s31.712,28.954,17.322,46.887c.03,1.089-6.342,3.4-6.342,3.4L79.865,30.594,54.782,45.383s-4.848-4.743-4.367-5.723",
    transform: "translate(99.129 6.76)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M99.387,79.855a34.775,34.775,0,0,1,12.982,14.8c4.737,10.2,51.993,123.368,51.993,123.368s7.287,30.6-6.92,45.894-67.024,69.21-67.024,69.21l-23.713-67.61,44.658-30.741s-2-4.917,2.914-6.192c0,0-2.55-2.731-.364-5.281L83.626,170.441S61.559,94.47,99.387,79.855",
    transform: "translate(133.901 160.292)",
    fill: "#99aac1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M147.838,139.962a25.97,25.97,0,0,1-2.6,3.305c-14.2,15.3-67.024,69.207-67.024,69.207L72.785,196.98,88.51,172.387Z",
    transform: "translate(146.101 280.945)",
    fill: "#7e90a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M82.453,138.326a.825.825,0,1,1-.692-1.5c.036-.015,11.882-5.741,26.536,1.35a.824.824,0,0,1-.716,1.486c-13.942-6.748-25.1-1.353-25.129-1.338m3-6.237c.018-.009,6.225-3.837,15.076-1.3a.825.825,0,1,0,.451-1.588,21.6,21.6,0,0,0-16.387,1.477.825.825,0,0,0,.86,1.407",
    transform: "translate(163.159 257.491)",
    fill: "#7e90a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M38.74,109.274C13.837,60.478,47.5,8.744,101.833,8.25s88.935,50.619,64.921,99.86c.647,2.52-12.952,11.244-12.952,11.244L102.42,72.712,51.9,120.281s-13.755-8.475-13.157-11.007",
    transform: "translate(61.003 16.554)",
    fill: "#cd3754",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M17.446,345.978l4.147,3.6s-3.618-.063-3.618,4.962,18.618,48.475,18.618,48.475.066,1.543-1.807,1.543h-19.7s-2.475.165-2.475-3.407-4.066-53.286-4.066-53.286Z",
    transform: "translate(17.156 694.479)",
    fill: "#00699c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M59.9,389.112l9.963,13.307s5.317,4.361,2.415,9.972-4.833,8.724-4.833,8.724a12.608,12.608,0,0,1-10.4,5.1H37.822c-5.079,0-21.391-.427-21.731-13.41s-1.816-38-1.816-38-.292-3.074-2.147-3.5-4.472-.986-3.747-4.727S16.9,338.538,16.9,338.538a4.72,4.72,0,0,1,4.4-3.317c3.7-.319,9.864,1.967,9.864,1.967Z",
    transform: "translate(16.574 672.826)",
    fill: "#00aed3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M17.227,415.816c0-3.335-3.81-43.083-2.911-51.885a21.456,21.456,0,0,1,.716-3.828l1.095-5.347c-1.681-9.4-3.452-19.2-5.29-29.3H43.385c.018,14.053.328,26.043,1.236,35.357.493,5.052,9.8,47.13,9.795,47.13s2.616,9.563,3.095,11.277a2.259,2.259,0,0,1-.421,2.433c-5.726,4.725-21,3.149-28.41,1.389s-11.452-3.891-11.452-7.229",
    transform: "translate(21.753 653.292)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M53.258,362.376l.484-3.272-2.2-.562s-.644,1.185-2.186.355-2-2.337-4.415-2.337h-20.7c-4.355,0-4.592,2.637-8.643,1.774s.057,5.209.057,5.209,16.928,2.078,17.469,2.183,20.131-3.35,20.131-3.35",
    transform: "translate(27.728 715.72)",
    fill: "#00aed3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M65.919,345.978l4.147,3.6s-3.618-.063-3.618,4.962,18.615,48.475,18.615,48.475.069,1.543-1.8,1.543h-19.7s-2.475.165-2.475-3.407-4.066-53.286-4.066-53.286Z",
    transform: "translate(114.456 694.479)",
    fill: "#00699c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M108.369,389.112l9.96,13.307s5.32,4.361,2.418,9.972-4.836,8.724-4.836,8.724a12.593,12.593,0,0,1-10.4,5.1H86.293c-5.076,0-21.391-.427-21.728-13.41s-1.819-38-1.819-38-.292-3.074-2.144-3.5-4.475-.986-3.747-4.727,8.52-28.043,8.52-28.043a4.72,4.72,0,0,1,4.4-3.317c3.7-.319,9.864,1.967,9.864,1.967Z",
    transform: "translate(113.873 672.826)",
    fill: "#00aed3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M65.7,415.816c0-3.335-3.81-43.083-2.911-51.885a21.436,21.436,0,0,1,.719-3.828l1.092-5.347c-1.681-9.4-3.452-19.2-5.29-29.3H91.857c.018,14.053.328,26.043,1.236,35.357.493,5.052,9.8,47.13,9.8,47.13s2.613,9.563,3.092,11.277a2.262,2.262,0,0,1-.418,2.433c-5.729,4.725-21,3.149-28.413,1.389S65.7,419.154,65.7,415.816",
    transform: "translate(119.051 653.292)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M101.731,362.376l.484-3.272-2.2-.562s-.644,1.185-2.186.355-2-2.337-4.415-2.337h-20.7c-4.355,0-4.6,2.637-8.646,1.774s.06,5.209.06,5.209,16.925,2.078,17.469,2.183,20.131-3.35,20.131-3.35",
    transform: "translate(125.025 715.72)",
    fill: "#00aed3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M242.783,278.548s-76.494,62.651-191.6,16.026,70.587-96.45,84.466-95.214,107.132,79.188,107.132,79.188",
    transform: "translate(27.573 400.129)",
    fill: "#7e90a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M135.679,188.739l-5.058,14.8s1.675,14.627,0,19.505-4.752,9.753-6.706,17.253-21.241,130.153-21.241,130.153,3.636,7.5-3.07,16.128c0,0,1.813,6.189-1.4,9.563L60.263,642.191a19.769,19.769,0,0,1-11.04,5.254c-6.986.935-17.322,1.311-22.074-1.125S9.824,634.5,9.824,634.5a2.763,2.763,0,0,1-.734-2.3C9.3,630.8,32.68,375.459,32.68,375.459s-2.517-12.192,2.511-16.69c0,0-3.353-7.693.559-12.192,0,0-2.237-13.313-1.678-23.442.361-6.514,4.652-80.884,7.819-134.4Z",
    transform: "translate(18.186 378.854)",
    fill: "#26377f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M108.858,204.249c-.553,1.516-1.08,3.143-1.54,4.914-1.828,7.007-18.778,114.5-21,128.613-26.413-2.7-51.049-10.67-68.993-17.911a7.937,7.937,0,0,1,1.825-4.424S16.916,302.127,17.475,292c.174-3.143,1.263-22.059,2.7-46.8,9.04-16,19.7-33.363,24.416-36.509,3.837-2.559,32.7-3.973,64.269-4.445",
    transform: "translate(34.782 409.988)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M150.948,188.739l-18.94,184.834s7.263,7.879.556,15.379c0,0,2.8,8.628-2.234,12L112.445,639.881a6.54,6.54,0,0,1-2.794,4.5c-2.586,1.78-17.536,3.188-25.5,2.812s-19.977-8.814-21.794-11.629c0,0-1.4-2.06-.842-9.563s5.446-231.053,5.446-231.053-5.449-6.565,0-16.877c0,0-2.935-3-.421-7.69L53.83,201.406l4.039-12.667Z",
    transform: "translate(108.053 378.854)",
    fill: "#26377f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M141.527,233.1l-9.5,92.664c-19.773,4.135-43.38,7.966-67.415,10.562L54.676,204.193c33.57-.078,64.708.845,66.834,2.52,1.519,1.2,9.894,12.08,20.017,26.386",
    transform: "translate(109.751 409.866)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M80.341,46.864h0A27.186,27.186,0,0,0,49.269,69.311L40.5,123.743a27.185,27.185,0,0,0,22.446,31.071h0a27.18,27.18,0,0,0,31.068-22.446l8.772-54.432A27.182,27.182,0,0,0,80.341,46.864",
    transform: "translate(80.597 93.378)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M107.985,67.693,64.075,69.127s-8.378.908-13.3,4.006l8.562,88.147L71,247.974S60.07,251.616,68.812,264c0,0-6.559,5.1-.731,9.47l-3.642,30.96s-4.186,5.464-.728,10.017l-2.186,8.739S30.018,392.944,19.089,449.039.149,535.733.149,535.733s-1.275,2.731,3.642,6.009,19.671,12.384,46.989,31.327,74.671,28.046,84.872,26.954a3.051,3.051,0,0,0,2.55-2c.547-1.822,22.221-123.3,22.221-123.3l17.124,117.107s.728,1.458,4.37,1.822,79.411-19.307,113.649-44.075c0,0,2.55-4.373,2.55-8.014s-20.759-97.259-35.33-135.139S224.9,310.255,224.9,310.255s1.459-3.278-.728-5.828c0,0,3.257-3.374.89-5.557l.752-45.621s11.84-29.5,11.84-41.889-6.192-51.725-6.192-51.725l1.822-55.367-30.8-15.827c-3.2,17.493-6.935,34.461-6.935,34.461l-44.872,92.537L108.857,89.024Z",
    transform: "translate(0.001 135.88)",
    fill: "#99aac1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M26.308,114.5l6.574,48.9s-10.929,3.642-2.186,16.026c0,0-6.556,5.1-.728,9.473l-3.645,30.957s-4.186,5.464-.725,10.017l-2.186,8.742s-1.693,3.744-4.424,10.189L139.809,188.7l-4.472-6.108s4.917-9.834,8.011-13.843,8.2-3.095,8.2-3.095l36.154,3.022s11.84-29.5,11.84-41.892c0-.355-.006-.737-.015-1.137-3.8,5.443-14.288,5.582-14.288,5.582L139.7,128.861l-8.084-14.414-14.4,6.812h0l-4.655,9.605-2.361-7.139-20.311,7.142s-31.324-4.373-42.983-7.47-11.581-13.569-11.581-13.569Z",
    transform: "translate(38.114 220.457)",
    fill: "#99aac1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M50.919,69.661l-2.965-.114L43.994,67.58l-6.009.274-2.078.069.872,21.331L78.6,215.668l44.872-92.54s3.738-16.967,6.935-34.461l-22.016-11.31L104.63,77.1c-12.45,20.4-44.989,9.479-53.71-7.434",
    transform: "translate(72.076 135.653)",
    fill: "#7e90a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M81.255,104.213,97.78,168.638a1.748,1.748,0,0,1-1.26,2.126L80.581,174.83a1.75,1.75,0,0,1-2.126-1.26L61.927,109.148a1.748,1.748,0,0,1,1.263-2.129l15.939-4.066a1.753,1.753,0,0,1,2.126,1.26",
    transform: "translate(124.188 206.548)",
    fill: "#2a54a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M78.211,107.972l-14.363,3.663,12.91,50.33L91.122,158.3Z",
    transform: "translate(128.163 216.731)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M51.876,122.6a1.03,1.03,0,0,1,1.976-.58c.027.087,9.4,31.174,9.4,49.53,0,9.792-1.08,52.555-2.412,97.217-1.128,37.8-2.442,76.914-3.437,98.441a1.029,1.029,0,0,1-2.057-.09c1-21.568,2.31-60.657,3.437-98.4,1.329-44.511,2.406-87.239,2.406-97.163,0-18.068-9.29-48.863-9.314-48.95",
    transform: "translate(104.046 243.438)",
    fill: "#7e90a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M60.249,71.608l40.8,160.635L27.83,92.371,39.216,66.508l22.4.635,2.55,4.556Z",
    transform: "translate(55.863 133.501)",
    fill: "#0786ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M76.353,73.843,49.994,214.181l58.287-89.975-.728-40.794L77.1,69.2Z",
    transform: "translate(100.353 138.904)",
    fill: "#0786ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M77.6,47.4s5.666-5.13,9.169-4.508,7.269,8.547,6.3,14.228-9.3,24.988-20.3,16.477S77.6,47.4,77.6,47.4",
    transform: "translate(138.272 85.992)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M70.454,50.066a1.291,1.291,0,0,0-.382,1.477.709.709,0,0,0,1.059.271s1.681,17.863,4.52,15.334,5.8-4.941,7.266-9.314-2.162-8.8-.632-9.846c1.459-1,2.782.857,2.9,1.035l.006.006,0,.006a11.811,11.811,0,0,1,1.419,3.434.714.714,0,0,0,1.074.511,1.331,1.331,0,0,0,.647-1.4c-.006-.018-1.459-6.872-6.384-7.055-4.706-.177-11.476,5.524-11.5,5.539",
    transform: "translate(140.456 89.37)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M46.557,44.476s-4.794-5.951-8.351-5.885-8.517,7.3-8.45,13.067,5.281,26.136,17.475,19.448-.674-26.63-.674-26.63",
    transform: "translate(59.727 77.461)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M48.657,47.668a1.3,1.3,0,0,1,.147,1.519.711.711,0,0,1-1.089.1s-4.454,17.379-6.863,14.438-4.953-5.789-5.72-10.336,3.513-8.354,2.162-9.629c-1.284-1.212-2.881.415-3.028.571l-.006.006,0,0v0a11.678,11.678,0,0,0-1.94,3.17.712.712,0,0,1-1.14.334,1.328,1.328,0,0,1-.421-1.48c.009-.018,2.517-6.559,7.41-5.972,4.676.562,10.471,7.254,10.489,7.272",
    transform: "translate(61.581 81.014)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M99.76,16.41C172.4,23.8,156.779,79.491,146.386,124.582c-4.373,18.979-15.987,29.4-15.987,29.4s-22.065,16.215-29.474,19.373a31.86,31.86,0,0,1-15,2,31.816,31.816,0,0,1-14.432-4.565C64.735,166.4,45.8,146.616,45.8,146.616S36.168,134.347,35.14,114.9C32.7,68.685,26.933,11.135,99.76,16.41",
    transform: "translate(68.083 32.261)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M71.9,46.062a28.1,28.1,0,0,1,3.777-2.71,11.224,11.224,0,0,1-3.777,2.71",
    transform: "translate(144.328 87.02)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M153.257,46.431c.217,9.488-1.11,19.6-3.037,29.76a10.816,10.816,0,0,1-7.795,3.988c-16.7.935-24.591-18.609-24.591-18.609C92.519,74.318,75.945,54.1,75.945,54.1c-24.043,17.3-40.98,5.828-40.98,5.828s10.2-27.866,22.768-32.238,78.5,8.014,89.605,11.84c2.553.878,4.55,3.449,5.918,6.9",
    transform: "translate(70.185 53.736)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M51.263,61.693a1.281,1.281,0,0,1,.653-2.478,31.538,31.538,0,0,0,8.4.671,1.281,1.281,0,0,1,.123,2.559,34.44,34.44,0,0,1-9.175-.752",
    transform: "translate(100.985 118.777)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M48.708,59.161a1.284,1.284,0,1,1,1.025-2.355,42.008,42.008,0,0,0,23.4,1.874,1.282,1.282,0,1,1,.493,2.517,44.8,44.8,0,0,1-24.915-2.036",
    transform: "translate(96.223 113.812)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M67.606,45.561h0a6.088,6.088,0,0,1,3.332,1.332,3.231,3.231,0,0,0,1.837-2.24,1.068,1.068,0,0,1,2.09.436,5.082,5.082,0,0,1-1.925,3.055,1.67,1.67,0,0,0,1.383-.65A1.071,1.071,0,1,1,76,48.833a3.6,3.6,0,0,1-2.92,1.465,6.131,6.131,0,0,1,.135,1.856l-.493,6.078a6.135,6.135,0,0,1-6.589,5.6h-.006a6.132,6.132,0,0,1-5.6-6.592l.49-6.078a6.136,6.136,0,0,1,6.592-5.6",
    transform: "translate(121.448 87.926)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M64.684,44.68a5,5,0,0,1-2.965-.469,5.591,5.591,0,0,1-2.264-3.774c.114-.541.821.391,3.648-.629,2.776-1,12.925-3.161,19.217,4.4,1.083,1.308.114,2.177-1.332,1.564a19.333,19.333,0,0,0-16.3-1.095",
    transform: "translate(119.324 77.759)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M58.458,43.675a4.992,4.992,0,0,0,3-.207,5.581,5.581,0,0,0,2.589-3.558c-.066-.55-.854.316-3.579-.95-2.676-1.245-12.595-4.288-19.532,2.692-1.194,1.206-.3,2.159,1.191,1.675a19.348,19.348,0,0,1,16.336.349",
    transform: "translate(81.048 74.71)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M56.945,56.541c.719-.547.37-3.188-.021-4.974-.295-1.35-.574-2.021-.962-1.994-.355-.171-.83.349-1.534,1.5-.935,1.528-2.1,3.87-1.6,4.658.665,1.041,3.167,1.531,4.117.806",
    transform: "translate(105.801 99.444)",
    fill: "#f9d4c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M59.261,47.6a1.112,1.112,0,0,0-2.189.394C57.43,50,59.5,61.415,59.186,62.4c-.265.635-1.606,1.407-2.192,1.684a7.091,7.091,0,0,1-3.3.725,1.113,1.113,0,1,0-.108,2.222,9.349,9.349,0,0,0,4.358-.932c1.131-.535,2.809-1.657,3.3-2.863.547-1.35-1.513-13.41-1.988-15.635",
    transform: "translate(105.442 93.707)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M49.878,44.689h0a6.077,6.077,0,0,0-3.5.779,3.229,3.229,0,0,1-1.453-2.508,1.067,1.067,0,1,0-2.132.1,5.073,5.073,0,0,0,1.407,3.323,1.651,1.651,0,0,1-1.26-.863,1.072,1.072,0,0,0-1.868,1.053,3.617,3.617,0,0,0,2.646,1.916,6.109,6.109,0,0,0-.427,1.807l-.493,6.078A6.134,6.134,0,0,0,48.4,62.962h0a6.133,6.133,0,0,0,6.589-5.606l.493-6.078a6.136,6.136,0,0,0-5.606-6.589",
    transform: "translate(82.158 84.185)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M50.029,139.487s8.772-2.346,10.6-2.9,6.724-10.225,8.682-12.892,14.513-6.986,15.839-16.763c0,0,.484-1.786,1.822-1.714s4.15,3.446,3.84,7.464a33.705,33.705,0,0,1-2.3,8.751s2.114,1.161,5.942.054,11.166-2.833,13.379-3.44a4.756,4.756,0,0,1,5.434,2.183,7.971,7.971,0,0,1,.117,6.971s3.407,1.152,4.282,3.615,1,5.467-.992,7.187c0,0,5.079,4.009,1.834,8.881,0,0,2.189,2.923.767,6s-14.793,8.8-18.113,9.711a43.754,43.754,0,0,1-14.961.619c-3.994-.779-5.69-1.57-7.69-.538s-17.229,8.21-17.229,8.21Z",
    transform: "translate(100.423 211.206)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M67.89,110.61a.825.825,0,0,1-.271,1.627,39.919,39.919,0,0,0-6.394-.364.823.823,0,0,1-.063-1.645,42.211,42.211,0,0,1,6.727.382M97.4,136.13a.823.823,0,1,1,.695,1.492l-11.362,5.341a.823.823,0,1,1-.695-1.492Zm-1.777-8.908a.824.824,0,1,1,.58,1.543l-13.951,5.278a.824.824,0,0,1-.58-1.543Zm-3.245-10.817a.825.825,0,0,1,.487,1.576L79.143,122.3a.824.824,0,1,1-.49-1.573Z",
    transform: "translate(121.182 221.217)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M43.443,69.522s-10.91,6.541-15.827,16.194S5.214,207.01,3.756,225.222s13.115,57.917,37.155,64.837,129.674-20.4,129.674-20.4a2.806,2.806,0,0,0,1.095-2.55c-.274-1.549-25.312-64.564-25.312-64.564s-.911-1.459-4.556-.911-67.2,12.564-67.2,12.564a6.305,6.305,0,0,0-7.741-4.646s1.275-4.553-2-7.831l9.106-80.138S80.893,68.04,43.443,69.522",
    transform: "translate(7.338 139.491)",
    fill: "#99aac1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M22.039,174.693c38.385-2.337,111.646-21.283,111.646-21.283a2.813,2.813,0,0,0,1.095-2.55c-.111-.62-4.2-11.109-9.052-23.454Z",
    transform: "translate(44.239 255.741)",
    fill: "#7e90a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M86.529,138.146l10.826,6.475a6.538,6.538,0,0,1,3.714,4.764c.433,3.362-1.095,7.873-1.095,7.873a10.947,10.947,0,0,1,.448,12.237s1.937,5.729-1.425,9.78c0,0,1.669,3.236.229,5.9a99.051,99.051,0,0,1-6.372,8.863,8.863,8.863,0,0,1-5.428,1.215c-3.4-.229-2.081-6.535-.385-8.126,0,0-5.876,1.609-8.829-.626s-.358-7.151,1.871-8.739c0,0-8.336,1.308-10.12-1.937s-.418-7.924,2.9-9.235c0,0-3.125-3.278-2.021-6.09s3.046-5.473,10.646-5.624l4.89-4.917Z",
    transform: "translate(138.856 277.299)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M85.222,182a.825.825,0,1,1-.186-1.639l4.343-.508a7.983,7.983,0,0,0,2.21-1.242c1.365-1.022,4.815-5.744,4.824-5.756a.825.825,0,0,1,1.35.947c-.012.015-3.642,4.965-5.188,6.126a9.764,9.764,0,0,1-2.767,1.516l-.048.015-.006,0h-.006l-.006,0-.108.018Zm-.129-37.45a.823.823,0,0,1-1.251-1.071c.006-.006,2.06-2.436,7.362-2.376a.824.824,0,0,1-.015,1.648c-4.532-.054-6.093,1.792-6.1,1.8M70.934,161.473a.823.823,0,1,1,.033-1.645l13.945.322.081.006v0a4.326,4.326,0,0,0,3.269-1.344c1.732-1.868,9.244-8.1,9.265-8.123a.826.826,0,1,1,1.068,1.26c-.021.018-7.539,6.264-9.127,7.981a6.182,6.182,0,0,1-4.652,1.868Zm7.3,11.169,8.712-.749.111-.015a10.738,10.738,0,0,0,4.736-2.09c2.117-1.738,7.208-5.573,7.224-5.585a.825.825,0,0,0-1.013-1.3c-.015.009-5.491,4.165-7.257,5.615a8.783,8.783,0,0,1-3.931,1.732h-.006L78.1,171a.825.825,0,1,0,.135,1.645m8.823-.764-.09.012Z",
    transform: "translate(140.767 283.242)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M37.914,113.377A.825.825,0,0,1,37.622,115c-.021,0-7.663-1.317-13.782,2.006a.824.824,0,0,1-.791-1.447c6.631-3.6,14.838-2.189,14.865-2.183m1.747,7.828a.822.822,0,1,1,.22,1.63l-7.75,1.044a.824.824,0,1,1-.217-1.633Zm7.693,4.652a.824.824,0,0,1,.316,1.618L18.141,133.3a.824.824,0,1,1-.316-1.618Z",
    transform: "translate(34.435 227.024)",
    fill: "#7e90a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M60.426,340.058c.051,3.076.226,6.92.469,11.073a73.1,73.1,0,0,0,25.89,2.61,64.1,64.1,0,0,0,8.2-1.242c-.8-3.765-1.57-7.452-2.225-10.676a93.934,93.934,0,0,1-11.774,1.428,93.94,93.94,0,0,1-10.068.2c-3.158-.147-6.947-1.564-10.489-3.392",
    transform: "translate(121.293 682.596)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M47.057,357.393c-.848-3.982-1.69-7.969-2.418-11.521-.394.078-.8.144-1.215.2a81.9,81.9,0,0,1-10.258.719c-4.649.015-9.127-.466-11.816-1.843a101.94,101.94,0,0,1-9.377-6.072c-.078,2.613.033,6.457.256,10.871A61.464,61.464,0,0,0,39.036,357.4a70.685,70.685,0,0,0,8.02-.009",
    transform: "translate(23.985 680.225)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M49.954,45.367s-.815,20.4-12.291,22.224c0,0-1.392-14.1-5.458-13.04l.451-23.806Z",
    transform: "translate(64.645 61.716)",
    fill: "#cd3754",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M72.429,37.629l-3.485,13.84s.785,16.125,8.58,23.61l6.5-16.718s2.857-5.819,5.554-2.95c0,0-2.689-16.636-1.859-16.254s-15.286-1.528-15.286-1.528",
    transform: "translate(138.391 75.532)",
    fill: "#cd3754",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M38.107,42.093s-12.694,29.956-.421,41.38S73.693,91.921,83.036,71.5c0,0,1.329,18.928,18.537,21.977s24.564-13.7,24.564-13.7-1.54,21.9,18.486,25.171,28.446-38.514,18.029-63.433S95.667,7.326,76.977,12.679,43.966,26.9,38.107,42.093",
    transform: "translate(64.913 22.512)",
    fill: "#cd3754",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M76.729,29.935a.825.825,0,0,1,1.633.232c-.015.1-4.475,33.047-41.453,27.742a.825.825,0,1,1,.232-1.633c35.336,5.067,39.576-26.251,39.588-26.341",
    transform: "translate(72.665 58.666)",
    fill: "#cd3754",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M73.54,54.8a1.367,1.367,0,1,0-1.365-1.365A1.368,1.368,0,0,0,73.54,54.8",
    transform: "translate(144.876 104.522)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M73.54,58.683a1.367,1.367,0,1,0-1.365-1.365,1.368,1.368,0,0,0,1.365,1.365",
    transform: "translate(144.876 112.306)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M73.54,62.408a1.367,1.367,0,1,0-1.365-1.365,1.368,1.368,0,0,0,1.365,1.365",
    transform: "translate(144.876 119.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M74.634,63.324a3.006,3.006,0,1,0-3-3,3.011,3.011,0,0,0,3,3",
    transform: "translate(143.782 115.042)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M72.524,52.737a.314.314,0,1,1,.629,0V75.6a.314.314,0,1,1-.629,0Z",
    transform: "translate(145.577 105.224)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M33.737,50.628a1.367,1.367,0,1,0-1.368-1.365,1.368,1.368,0,0,0,1.368,1.365",
    transform: "translate(64.974 96.137)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M33.737,54.506a1.367,1.367,0,1,0-1.368-1.365,1.368,1.368,0,0,0,1.368,1.365",
    transform: "translate(64.974 103.922)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M33.737,58.231a1.367,1.367,0,1,0-1.368-1.365,1.368,1.368,0,0,0,1.368,1.365",
    transform: "translate(64.974 111.399)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M34.829,59.147a3.006,3.006,0,1,0-3-3,3.008,3.008,0,0,0,3,3",
    transform: "translate(63.882 106.658)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M32.719,48.56a.314.314,0,1,1,.629,0V71.424a.314.314,0,1,1-.629,0Z",
    transform: "translate(65.677 96.84)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlImg3);
export default __webpack_public_path__ + "static/media/girl-img3.20921b0d578989a2b4ccb92b4614faf1.svg";
export { ForwardRef as ReactComponent };